import { z } from 'zod';
import { SServiceSlot } from './service-slot';

export const SError = z.object({
  status: z.boolean(),
  msg: z.string(),
  code: z.number(),
});
export type TError = z.infer<typeof SError>;

export const SCreateBookServiceSlotResponse = z.object({
  data: SServiceSlot.optional(),
  error: SError,
});
export type TCreateBookServiceSlotResponse = z.infer<
  typeof SCreateBookServiceSlotResponse
>;
